import styles from './AboutCompanyPage.module.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Button from '../../components/UI/Button/Button';
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom';
import { CAREERS_PAGE } from '../../router/paths';
import Loader from '../../components/Loader/Loader';
import { LoaderContext } from '../../components/Loader/LoaderContext';
import { useEffect, useContext, useState } from 'react';

export default function AboutCompanyPage() {
  const navigate = useNavigate();
  const { isInitialLoad, setIsInitialLoad } = useContext(LoaderContext);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    document.documentElement.classList.add('black');
    document.body.classList.add('black');

    return () => {
      document.documentElement.classList.remove('black');
      document.body.classList.remove('black');
    };
  }, []);

  const updateWindowWidth = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', updateWindowWidth);
    return () => {
      window.removeEventListener('resize', updateWindowWidth);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsInitialLoad(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, [setIsInitialLoad]);

  const handleCareersNavigate = () => {
    navigate(CAREERS_PAGE);
  };

  const buttonStyle = {
    width: windowWidth <= 576 ? '100%' : 'fit-content',
  };

  return (
    <div className={styles.page}>
      <Helmet>
        <title>О компании | Восток Строй</title>
        <meta name="description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="keywords" content="недвижимость, девелопер, Каспийск, новостройки, квартиры" />
        <meta name="author" content="Восток Строй" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://vostokstroy.com/about" />

        <meta property="og:title" content="Ведущему девелоперу Каспийска — 10 лет" />
        <meta property="og:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta property="og:image" content="https://vostokstroy.com/open-graphs/about-opengraph.jpg" />
        <meta property="og:url" content="https://vostokstroy.com/about" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Восток Строй" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Ведущему девелоперу Каспийска — 10 лет" />
        <meta name="twitter:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="twitter:image" content="https://vostokstroy.com/open-graphs/about-opengraph.jpg" />

        <link rel="icon" type="image/svg+xml" href="/favicons/main-fav-32x32.svg" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicons/main-fav-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicons/main-fav-32x32.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/favicons/main-apple-touch-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="180x180" href="/favicons/main-fav-180x180.png" />
      </Helmet>
      {isInitialLoad ? (
        <Loader />
      ) : (
        <>
          <Header theme='dark'></Header>
          <div className={styles.about_company}>
            <div className={styles.title_screen_bg}></div>
            <div className={styles.wrapper}>
              <div className={styles.title_screen_wrapper}>
                <div className={styles.title}>
                  <h1>
                    Ведущему
                    <br />
                    девелоперу Каспийска
                    <br /> — 10 лет
                  </h1>
                </div>
              </div>
              <div className={styles.projects_wrapper}>
                <div className={styles.text_wrapper}>
                  <div className={styles.text_title}>
                    <h3>Ведущий девелопер Каспийска</h3>
                  </div>
                  <div className={styles.text_info}>
                    <p className='text_body_b2'>
                      Мы&nbsp;начали свой путь в&nbsp;2014&nbsp;году. С&nbsp;первого&nbsp;же проекта мы&nbsp;сотрудничаем с&nbsp;ведущими проектировщиками и&nbsp;архитекторами, что позволило нам сдать уже с&nbsp;десяток проектов.
                    </p>
                  </div>
                </div>
                <div className={styles.projects_content}>
                  <div className={styles.projects_image}></div>
                  <div className={styles.projects}>
                    <div className={styles.projects_first_line}>
                      <div className={styles.project}>
                        <div className={styles.project_title}>
                          <h2>72 тысячи</h2>
                        </div>
                        <div className={styles.project_text}>
                          <p className='text_body_b2'>жилых квадратных метров</p>
                        </div>
                      </div>
                      <div className={styles.project}>
                        <div className={styles.project_title}>
                          <h2>9 проектов</h2>
                        </div>
                        <div className={styles.project_text}>
                          <p className='text_body_b2'>реализовано</p>
                        </div>
                      </div>
                      <div className={styles.project}>
                        <div className={styles.project_title}>
                          <h2>15 тысяч</h2>
                        </div>
                        <div className={styles.project_text}>
                          <p className='text_body_b2'>коммерческих квадратных метров</p>
                        </div>
                      </div>
                    </div>
                    <div className={styles.projects_second_line}>
                      <div className={styles.project}>
                        <div className={styles.project_title}>
                          <h2>свыше 4000 человек</h2>
                        </div>
                        <div className={styles.project_text}>
                          <p className='text_body_b2'>проживает в наших проектах</p>
                        </div>
                      </div>
                      <div className={styles.project}>
                        <div className={styles.project_title}>
                          <h2>1341 квартира</h2>
                        </div>
                        <div className={styles.project_text}>
                          <p className='text_body_b2'>заселена</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.info_wrapper}>
                <div className={styles.text_wrapper}>
                  <div className={styles.text_title}>
                    <h3>Проверены временем</h3>
                  </div>
                  <div className={styles.text_info}>
                    <p className='text_body_b2'>
                      Наша миссия&nbsp;&mdash; превышать ожидания клиентов, предоставляя не&nbsp;просто крышу над головой, а&nbsp;свой родной дом.
                    </p>
                  </div>
                </div>
                <div className={styles.info_content_wrapper}>
                  <div className={styles.info_content_wrapper_left}>
                    <div className={styles.left_top}>
                      <div className={styles.icon_scales}></div>
                      <h3>
                        Доступные цены&nbsp;&mdash;<br/>квартиры от&nbsp;4,8 млн&nbsp;₽
                      </h3>
                    </div>
                    <div className={styles.info_content_block_text_one}>
                      <h3>Квартиры всех классов</h3>
                    </div>
                  </div>
                  <div className={styles.info_content_wrapper_right}>
                    <div className={styles.info_content_block_text_two}>
                      <h3>Инфраструктура с&nbsp;внимательным подходом</h3>
                    </div>
                    <div className={styles.right_bottom}>
                      <div className={styles.icon_ball}>
                      </div>
                      <h3>Детские и&nbsp;спортивные площадки, места для прогулок и&nbsp;отдыха</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.join_wrapper}>
                <div className={styles.text_wrapper}>
                  <div className={styles.text_title}>
                    <h2>
                      Большая команда
                      <br />с большими амбициями
                    </h2>
                  </div>
                  <div className={styles.text_info}>
                    <p className='text_body_b2'>
                      Мы&nbsp;продолжаем следовать концепции абсолютного комфорта и&nbsp;потому еще активнее развиваем недвижимость совместно с&nbsp;нашей командой.
                    </p>
                  </div>
                </div>
                <div className={styles.join_content}>
                  <div className={styles.text_title}>
                    <h3>Вместе строим лучшее&nbsp;&mdash; от&nbsp;плана до&nbsp;воплощения</h3>
                  </div>
                  <Button width='fit-content' roundType='small_rounded' onClick={handleCareersNavigate} style={buttonStyle}>Присоединиться</Button>
                </div>
              </div>
            </div>
          </div>
          <Footer theme='dark'></Footer>
        </>
      )}
    </div>
  );
}